import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, publishLast, refCount } from 'rxjs/operators';
import { CommonLink, CommonLinksRealModel } from './common-link';
import { deserialize } from 'santee-dcts';
import { HttpClient } from '@angular/common/http';
import { Settings } from '../core';

@Injectable()
export class CommonLinksStorage {
    private readonly commonLinks: Observable<CommonLink[]>;

    constructor(private http: HttpClient, private settings: Settings) {
        this.commonLinks = this.loadAll()
            .pipe(
                publishLast(),
                refCount()
            );
    }

    public get all(): Observable<CommonLink[]> {
        return this.commonLinks;
    }

    private loadAll(): Observable<CommonLink[]> {
        return this.http.get(`${this.settings.apiUrl}/commonLinks`)
            .pipe(
                map((rawData) => deserialize(rawData, CommonLinksRealModel).commonLinks)
            );
    }
}